import { Dropdown } from "react-bootstrap";

interface Props {
  children: React.ReactNode;
  styles?: React.CSSProperties;
  className?: string;
}

const TableDropdownMenu = ({
  children,
  styles,
  className,
}: Readonly<Props>) => {
  return (
    <Dropdown.Menu
      renderOnMount
      popperConfig={{
        strategy: "fixed",
      }}
      style={styles}
      className={className}
    >
      {children}
    </Dropdown.Menu>
  );
};

export default TableDropdownMenu;
